import SubjectOwnerModalContainer from './subject_owner_modal_container';

const SubjectOwnerModal = SubjectOwnerModalContainer;

export default SubjectOwnerModal;
